import { FC } from 'react'

// hooks
import { useAppSelector, useAppDispatch } from '@/hooks'
// features
import {
  subscriptionSelectSubscriptionCancelModalOpen,
  subscriptionCloseSubscriptionCancelModal,
} from '@/features'
// components
import { ModalLayout } from '@/components'

// components
import { SubscriptionCancelCard } from './components'
// styles
import { styles } from './styles'

type SubscriptionCancelModalProps = {}

export const SubscriptionCancelModal: FC<SubscriptionCancelModalProps> = () => {
  const dispatch = useAppDispatch()
  const subscriptionCancelModalOpen = useAppSelector(
    subscriptionSelectSubscriptionCancelModalOpen,
  )

  return (
    <div css={styles().modal.main}>
      {subscriptionCancelModalOpen && (
        <ModalLayout
          background="opaque"
          onOutsideClick={() => dispatch(subscriptionCloseSubscriptionCancelModal())}
        >
          <div css={styles().modal.content}>
            <SubscriptionCancelCard />
          </div>
        </ModalLayout>
      )}
    </div>
  )
}

SubscriptionCancelModal.propTypes = {}
